<template>
  <div class="pwc-thanks-info" :style="cStyle">
    <!-- <v-img :src="logo" class="pwc-youplus-logo" /> -->
    <embed :src="submitIcon" style="width:200px;">
    <div class="pwc-info-tilte">
      已提交！
    </div>
  </div>
</template>

<script>
import youplusWechatQrcode from '@/assets/you-plus-wechat-qrcode.jpg'
import logo from '@/assets/logo.png'
import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()
import submitIcon from '@/assets/submit.svg'

export default {
  data() {
    return {
      youplusWechatQrcode,
      logo,
      submitIcon
    }
  },
  computed: {
    cStyle() {
      return isMobile ? {} : { height: '70vh' }
    }
  }
}
</script>

<style lang="scss">
.pwc-thanks-info {
  font-family: "Microsoft YaHei", Georgia, "Times New Roman", Times, serif;
  text-align: center;
  max-width: 640px;
  margin: auto;
  padding-top: 100px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #fff;
  .pwc-info-tilte {
    display: flex;
    justify-content: center;
    align-self: center;
  }
  .pwc-info-content {
    font-weight: bold;
    margin-bottom: 16px;
  }
  .pwc-info-qrcode {
    text-align: center;
    img {
      width: 180px;
      height: 180px;
    }
  }
  .pwc-info-tilte,
  .pwc-info-content {
    font-size: 22px;
  }
  .self-center {
    margin-top: 50px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    button {
      background-color: rgb(208, 74, 2);
      padding: 5px;
    }
  }
}
</style>
